import { CustomerScopeSelector } from "portal/components/customers/CustomerScopeSelector";
import { determinePlantProfileChanges } from "portal/utils/categoryCollection/plantProfile";
import { Header } from "portal/components/header/Header";
import { Page } from "portal/components/Page";
import { PlantProfileList } from "portal/components/categoryCollectionProfile/PlantProfileList";
import { portalEndpoints } from "portal/state/portalApi";
import { useCustomerScopeFilter } from "portal/components/customers/useCustomerScopeFilter";
import { useMutationPopups } from "portal/utils/hooks/useApiPopups";
import { useTranslation } from "react-i18next";
import React, { FC } from "react";

export const PlantProfileListPage: FC = () => {
  const { t } = useTranslation();
  const { customerUuid } = useCustomerScopeFilter();
  const [applyPlantProfileChanges] = useMutationPopups(
    portalEndpoints.applyCustomerPlantProfileChanges.useMutation(),
    {
      success: t("utils.actions.createdLong", {
        subject: t(
          "models.categoryCollectionProfiles.categoryCollectionProfile_title_one"
        ),
      }),
    }
  );

  return (
    <>
      <Header title={t("views.plantProfiles.title")}>
        <CustomerScopeSelector />
      </Header>
      <Page>
        {customerUuid ? (
          <PlantProfileList
            customerUuid={customerUuid}
            useLazyListQuery={
              portalEndpoints.listCustomerPlantProfiles.useLazyQuery
            }
            onCreateProfile={(unsavedPlantProfile) =>
              applyPlantProfileChanges({
                ccUUID: unsavedPlantProfile.id,
                customerUuid,
                changes: determinePlantProfileChanges(
                  undefined,
                  unsavedPlantProfile
                ),
              })
            }
          />
        ) : undefined}
      </Page>
    </>
  );
};
